import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowLeft } from 'lucide-react';

const CGV = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAF9F6] py-24">
      <div className="max-w-4xl mx-auto px-6">
        {/* Back Button */}
        <Button
          onClick={() => navigate('/')}
          variant="outline"
          className="mb-8 border-[#4A6B96] text-[#4A6B96] hover:bg-[#4A6B96] hover:text-white"
        >
          <ArrowLeft size={18} className="mr-2" />
          Retour à l'accueil
        </Button>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-lg p-12">
          <h1 className="text-4xl font-bold text-[#4A6B96] mb-8">Conditions Générales de Vente</h1>

          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Article 1 - Objet</h2>
              <p>
                Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre Esprit Ouest 
                et ses clients concernant la location de bureaux privatifs, salles de réunion et espaces de séminaire.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Article 2 - Prix et Tarifs</h2>
              <p>
                Les prix sont exprimés en euros TTC. Ils comprennent :
              </p>
              <ul className="list-disc list-inside mt-4 space-y-2">
                <li>La location de l'espace choisi</li>
                <li>Le ménage hebdomadaire</li>
                <li>Les charges (électricité, eau, chauffage, TF)</li>
                <li>L'accès 24/7 pour les bureaux privés</li>
              </ul>
              <p className="mt-4">
                Services en option facturés en supplément : Internet haut débit, Ameublement.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Article 3 - Modalités de Réservation</h2>
              <p>
                La réservation peut s'effectuer :
              </p>
              <ul className="list-disc list-inside mt-4 space-y-2">
                <li>Par téléphone : 01 71 42 72 15</li>
                <li>Par email : contact@esprit-ouest.fr</li>
                <li>Sur place lors d'une visite</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Article 4 - Durée du Contrat</h2>
              <p>
                Nous proposons :
              </p>
              <ul className="list-disc list-inside mt-4 space-y-2">
                <li>Contrats journaliers sans engagement</li>
                <li>Contrats mensuels sans engagement</li>
                <li>Contrats trimestriels avec tarif préférentiel</li>
                <li>Contrats annuels avec tarif préférentiel</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Article 5 - Paiement</h2>
              <p>
                Le paiement s'effectue :
              </p>
              <ul className="list-disc list-inside mt-4 space-y-2">
                <li>Pour les contrats journaliers : à la réservation</li>
                <li>Pour les contrats mensuels : le 1er de chaque mois</li>
                <li>Pour les contrats trimestriels/annuels : selon échéancier convenu</li>
              </ul>
              <p className="mt-4">
                Moyens de paiement acceptés : virement bancaire, chèque, carte bancaire.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Article 6 - Résiliation</h2>
              <p>
                Les contrats journaliers et mensuels sont résiliables sans préavis. 
                Les contrats trimestriels et annuels peuvent être résiliés moyennant un préavis d'un mois.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Article 7 - Obligations du Client</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>Utiliser les locaux conformément à leur destination</li>
                <li>Respecter le règlement intérieur</li>
                <li>Respecter les autres locataires</li>
                <li>Ne pas sous-louer l'espace</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Article 8 - Responsabilité</h2>
              <p>
                Esprit Ouest décline toute responsabilité en cas de vol ou détérioration des biens personnels du client. 
                Il est recommandé de souscrire une assurance professionnelle.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Article 9 - Litiges</h2>
              <p>
                En cas de litige, une solution amiable sera recherchée en priorité. 
                À défaut, le tribunal compétent sera celui du siège social d'Esprit Ouest.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Article 10 - Acceptation</h2>
              <p>
                La réservation d'un espace implique l'acceptation pleine et entière des présentes CGV.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CGV;
